import { render, staticRenderFns } from "./recipe-feedbackStatus.vue?vue&type=template&id=32027518&scoped=true&"
import script from "./recipe-feedbackStatus.vue?vue&type=script&lang=js&"
export * from "./recipe-feedbackStatus.vue?vue&type=script&lang=js&"
import style0 from "./recipe-feedbackStatus.vue?vue&type=style&index=0&id=32027518&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32027518",
  null
  
)

export default component.exports